import React from "react";
import ModalContainer from "../../../../../shared/components/modals/ModalContainer";

export const OrderExportErrorModal = ({ error, onClose }: { error?: string; onClose: () => void }) => (
  <ModalContainer
    isOpen={Boolean(error)}
    onClose={onClose}
    title="Export could not be completed"
    subtitle="We were unable to prepare your order file."
    size="md"
    autoHeight={true}
    fullscreenOverlay={true}
    closeOnBackdropClick={false}
    footer={
      <div className="tw-flex tw-justify-end">
        <button type="button" onClick={onClose} className="tw-flex tw-h-10 tw-items-center tw-justify-center tw-rounded-lg tw-bg-primary tw-px-4 tw-text-sm tw-font-bold tw-text-white hover:tw-bg-primary/90" data-testid="export-error-close">Close</button>
      </div>
    }
  >
    <div className="tw-bg-gray-50 tw-p-6">
      <div className="tw-flex tw-items-start tw-gap-4 tw-rounded-xl tw-border tw-border-red-200 tw-bg-red-50 tw-p-4" role="alert" data-testid="export-error-modal">
        <span className="material-symbols-outlined tw-text-2xl tw-text-red-600">error</span>
        <div className="tw-min-w-0">
          <h3 className="tw-text-sm tw-font-bold tw-text-red-900">Export failed</h3>
          <p className="tw-mt-1 tw-break-words tw-text-sm tw-leading-6 tw-text-red-800">{error}</p>
          <p className="tw-mt-3 tw-text-xs tw-leading-5 tw-text-red-700">Check your selections and template, then try again. If the problem continues, contact support.</p>
        </div>
      </div>
    </div>
  </ModalContainer>
);
